import React, { useEffect, useState, useMemo } from "react";
import MasterLayout from "../Sections/MasterLayout";
import Loader from "./Loader";
import { CheckCircle } from "lucide-react";
import {
  get_all_pod,
  server_post_json,
} from "../../ServiceConnection/serviceconnection";

const STATUS_FILTERS = ["all", "Pending", "Processing", "Done"];

export default function PodRequest() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState("all");

  /* ===============================
     FETCH POD REQUESTS
  =============================== */
  const master_get_data = async () => {
    try {
      setLoading(true);

      const response = await server_post_json(get_all_pod, {});

      setRequests(response?.data?.data || []);
    } catch (err) {
      console.error("Failed to load POD requests", err);
      setRequests([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    master_get_data();
  }, []);

  /* ===============================
     FILTERED DATA
  =============================== */
  const filteredRequests = useMemo(() => {
    if (statusFilter === "all") return requests;
    return requests.filter((r) => r.status === statusFilter);
  }, [requests, statusFilter]);

  /* ===============================
     LOCAL STATUS UPDATE (UI ONLY)
     (Later API laga sakte ho)
  =============================== */
  const updateStatus = (id, status) => {
    setRequests((prev) =>
      prev.map((r) =>
        r._id === id ? { ...r, status } : r
      )
    );
  };

  return (
    <MasterLayout>
      {loading && <Loader />}

      <div className="px-3 sm:px-4 py-6">
        {/* HEADER */}
        <div className="mb-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div>
            <h2 className="text-lg sm:text-2xl font-bold text-gray-800">
              POD Requests
            </h2>
            <p className="text-xs sm:text-sm text-gray-500">
              Custom print requests from users
            </p>
          </div>

          {/* STATUS FILTER */}
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="w-full sm:w-44 border rounded-lg px-3 py-2 text-sm"
          >
            {STATUS_FILTERS.map((s) => (
              <option key={s} value={s}>
                {s === "all" ? "All Status" : s}
              </option>
            ))}
          </select>
        </div>

        {/* TABLE */}
        <div className="bg-white border rounded-xl overflow-x-auto">
          <table className="w-full min-w-[900px]">
            <thead className="bg-gray-50 border-b">
              <tr>
                <th className="px-4 py-3 text-left text-xs text-gray-500">
                  Product / User
                </th>
                <th className="px-4 py-3 text-left text-xs text-gray-500">
                  Front Design
                </th>
                <th className="px-4 py-3 text-left text-xs text-gray-500">
                  Back Design
                </th>
                <th className="px-4 py-3 text-left text-xs text-gray-500">
                  Details
                </th>
                <th className="px-4 py-3 text-left text-xs text-gray-500">
                Instructions
                </th>
                {/* <th className="px-4 py-3 text-left text-xs text-gray-500">
                  Status
                </th>
                <th className="px-4 py-3 text-right text-xs text-gray-500">
                  Action
                </th> */}
              </tr>
            </thead>

            <tbody className="divide-y">
              {filteredRequests.map((r) => (
                <tr key={r._id} className="hover:bg-gray-50">
                  {/* PRODUCT + USER */}
                  <td className="px-4 py-3 text-sm font-medium">
                    {r.product?.title || r.product}
                    <div className="text-xs text-gray-500 mt-0.5">
                      User:{" "}
                      <span className="font-medium">
                        {r.user_id?.email || r.user_id}
                      </span>
                    </div>
                    <div className="text-[11px] text-gray-400">
                      {new Date(r.createdAt).toLocaleDateString()}
                    </div>
                  </td>

                  {/* FRONT DESIGN */}
                  <td className="px-4 py-3">
                  {r.frontDesign ? (
    <a
      href={r.frontDesign}
      target="_blank"
      rel="noopener noreferrer"
      className="block hover:opacity-90 transition-opacity"
    >
      <img
        src={r.frontDesign}
        alt="Front design"
        className="w-10 h-10 rounded border object-cover"
      />
    </a>
  ) : (
    <span className="text-xs text-gray-400">—</span>
  )}
                  </td>

                  {/* BACK DESIGN */}
                  <td className="px-4 py-3">
                  {r.backDesign ? (
    <a
      href={r.backDesign}
      target="_blank"
      rel="noopener noreferrer"
      className="block hover:opacity-90 transition-opacity"
    >
      <img
        src={r.backDesign}
        alt="Back design"
        className="w-10 h-10 rounded border object-cover"
      />
    </a>
  ) : (
    <span className="text-xs text-gray-400">—</span>
  )}
                  </td>

                  {/* DETAILS */}
                  <td className="px-4 py-3 text-sm">
                    <div>
                      {r.color} / {r.quality}
                    </div>
                    <div className="text-xs text-gray-500">
                      {Array.isArray(r.sides)
                        ? r.sides.join(", ")
                        : ""}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-sm">
                    <div className="text-xs text-gray-500">
                   
                        {r.instructions}
                    </div>
                  </td>

                  {/* STATUS */}
                  {/* <td className="px-4 py-3">
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium
                        ${
                          r.status === "Pending"
                            ? "bg-yellow-100 text-yellow-800"
                            : r.status === "Processing"
                            ? "bg-blue-100 text-blue-700"
                            : "bg-green-100 text-green-700"
                        }`}
                    >
                      {r.status}
                    </span>
                  </td> */}

                  {/* ACTION */}
                  {/* <td className="px-4 py-3 text-right">
                    {r.status !== "Done" ? (
                      <button
                        onClick={() =>
                          updateStatus(r._id, "Done")
                        }
                        className="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium bg-[var(--primary-color)] hover:bg-[var(--primary-hover)] text-white rounded-lg"
                      >
                        <CheckCircle className="w-4 h-4" />
                        Mark Done
                      </button>
                    ) : (
                      <span className="text-xs text-gray-500">
                        Completed
                      </span>
                    )}
                  </td> */}
                </tr>
              ))}

              {filteredRequests.length === 0 && !loading && (
                <tr>
                  <td
                    colSpan="6"
                    className="px-4 py-10 text-center text-sm text-gray-500"
                  >
                    No POD requests found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </MasterLayout>
  );
}
